<template>
  <div id="well">
    <!-- banner -->
    <div class="banner"></div>
    <!-- 最新网申 -->
    <div class="newest-job">
      <div class="wrap">
        <div class="index-tit-wrap">
          <h2 class="index-tit">最新职位</h2>
          <div class="update-date" @click="updateDate" v-if="hasData">
            <img
              src="@/assets/img/update.png"
              class="update-icon"
              :class="{ 'update-icon-on': isUpdate }"
              alt=""
            />
            换一批
          </div>
        </div>
        <ul class="tab-wrap">
          <li
            class="tab-tit"
            v-for="(value, key, index) in industry"
            :key="index"
            :class="{ tabcur: tabNum == key }"
            @click="tabChange(key)"
          >
            {{ value }}
          </li>
        </ul>
        <NewJob :newJobData="newJobData" v-if="hasData"></NewJob>
        <div id="nullData" v-else>
          <img src="@/assets/img/null.png" class="search-null-logo" alt="" />
          <p class="search-null-tit">暂无数据</p>
        </div>
      </div>
    </div>
    <main class="wrap">
      <!-- 名企招聘 -->
      <div class="well-campany">
        <h2 class="index-tit">特别推荐</h2>
        <WellCompany :wellCompanyData="wellCompanyData"></WellCompany>
        <div class="fenye">
          <a-pagination
            v-model="current"
            :total="wellCompanyTotal"
            :page-size="12"
            @change="onChange"
            show-less-items
          />
        </div>
      </div>
    </main>
  </div>
</template>
<script>
import NewJob from "@/components/NewJob.vue";
import WellCompany from "@/components/WellCompany.vue";
import {
  getIndustryList,
  getNewRecruitmentJobList,
  getWellCompany,
} from "@/api/wellcompany.js";

export default {
  components: {
    WellCompany,
    NewJob,
  },
  data() {
    return {
      tabNum: 1,
      current: 1,
      industry: {},
      wellCompanyData: [],
      newJobData: [],
      isUpdate: false,
      newRecruitmentTotalPage: 0,
      newRecruitmentEnd: 0,
      newRecruitmentNow: 1,
      wellCompanyTotal: 0,
      wellCompanyEnd: 0,
      hasData: false,
    };
  },
  created() {
    this.getIndustry();
    this.getNewRecruitment(1, 1, 3);
    this.getWell(1, 12);
  },
  methods: {
    tabChange(id) {
      this.tabNum = id;
      this.getNewRecruitment(id, 1, 3);
    },
    // 换一批
    updateDate() {
      if (this.newRecruitmentTotalPage != 1) {
        this.isUpdate = !this.isUpdate;
        this.newRecruitmentNow = this.newRecruitmentNow + 1;
        if (this.newRecruitmentNow == this.newRecruitmentTotalPage) {
          this.getNewRecruitment(
            this.tabNum,
            this.newRecruitmentNow,
            this.newRecruitmentEnd
          );
          this.newRecruitmentNow = 0;
        } else {
          this.getNewRecruitment(this.tabNum, this.newRecruitmentNow, 3);
        }
      } else {
        this.$message.warning("只有这么多数据了！");
      }
    },
    // 行业列表
    getIndustry() {
      getIndustryList()
        .then((res) => {
          this.industry = res;
        })
        .catch((rej) => {
          console.log(rej);
        });
    },
    // 名企首页最新网申
    getNewRecruitment(industry, pageIndex, pageSize) {
      let data = {
        industry: industry,
        pageIndex: pageIndex,
        pageSize: pageSize,
      };
      getNewRecruitmentJobList(data)
        .then((res) => {
          if (res.success) {
            this.newJobData = res.data;
            if (res.totalCount != 0) {
              this.hasData = true;
            } else {
              this.hasData = false;
            }
            this.newRecruitmentTotalPage = Math.ceil(res.totalCount / 3);
            this.newRecruitmentEnd = res.totalCount % 3;
            if (this.newRecruitmentEnd == 0) {
              this.newRecruitmentEnd = 3;
            }
          }
        })
        .catch((rej) => {
          console.log(rej);
        });
    },
    // 名企首页特别推荐
    getWell(pageIndex, pageSize) {
      let data = {
        pageIndex: pageIndex,
        pageSize: pageSize,
      };
      getWellCompany(data)
        .then((res) => {
          if (res.success) {
            this.wellCompanyData = res.data;
            this.wellCompanyTotal = res.totalCount;
            this.wellCompanyEnd = res.totalCount % 3;
            if (this.wellCompanyEnd == 0) {
              this.wellCompanyEnd = 12;
            }
          }
        })
        .catch((rej) => {
          console.log(rej);
        });
    },
    // 名企推荐翻页
    onChange(pageNumber) {
      this.getWell(pageNumber, 12);
    },
  },
};
</script>
<style scoped>
#well {
  padding-top: 64px;
}
.wrap {
  width: 1200px;
  margin: 0 auto;
}
.banner {
  width: 100%;
  height: 400px;
  background: url("./../../assets/img/mingqi.png") center no-repeat;
}
.tab-wrap {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
  margin-bottom: 30px;
}
.tab-tit {
  font-size: 16px;
  line-height: 22px;
  padding: 14px 0;
  cursor: pointer;
}
.tabcur {
  position: relative;
  color: #3b87ff;
}
.tabcur::after {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  content: "";
  height: 2px;
  background: #3b87ff;
}
.newest-job {
  background: #fff;
  padding: 40px 0 30px;
}
.index-tit-wrap {
  display: flex;
  justify-content: space-between;
}
.index-tit {
  font-size: 30px;
  color: #333;
  margin-bottom: 12px;
}
.well-campany .index-tit {
  margin: 38px 0;
}
.update-date {
  height: 30px;
  display: flex;
  align-items: center;
  padding: 5px 15px;
  border-radius: 15px;
  font-size: 14px;
  border: 1px solid #3b87ff;
  color: #3b87ff;
  cursor: pointer;
}
.update-icon {
  width: 12px;
  height: 12px;
  margin-right: 10px;
  transition: all 0.3s ease-in;
}
.update-icon-on {
  transform: rotate(360deg);
  transition: all 0.3s ease-in;
}
.fenye {
  text-align: center;
  margin: 10px 0 40px;
}
#nullData {
  height: 190px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  padding: 35px 0 40px;
}
.search-null-logo {
  width: 72px;
  height: 72px;
}
.search-null-tit {
  color: #999999;
  line-height: 20px;
  margin-top: 12px;
  width: 100%;
  text-align: center;
}
</style>
